import { Box, Table, TableBody, TableCell, TableRow, useTheme } from '@mui/material';
import { useLocale, getLocaleNumberFormatTwoDecimals } from '@repo/i18n';
import { capitalize } from '@repo/common-utils/TextUtils';
import { PriceSummary } from '@repo/widget-utils/price-helper';
import { configurationAtom } from '@repo/widget-utils/widgetsConfiguration';
import { useAtom } from 'ximple';

import type { JSX } from 'react';

export default function SummaryVat(props: {
    priceSummary: PriceSummary;
    invertedColorsClass?: Record<string, unknown>;
}): JSX.Element | null {
    const { t, locale } = useLocale();
    const [configuration] = useAtom(configurationAtom);
    const theme = useTheme();

    const vatAmountInfoKeysSorted = Object.keys(props.priceSummary.vatAmountInfo).sort(
        (keyA, keyB) => {
            return -(parseFloat(keyA) - parseFloat(keyB));
        },
    );

    if (configuration.hideVat) return null;

    const cellSx = {
        p: 0,
        border: 'none',
        color: 'text.secondary',
        ...props.invertedColorsClass,
    };

    return (
        <Box
            borderTop={`1px solid ${theme.palette.grey[400]}`}
            borderBottom={`1px solid ${theme.palette.grey[400]}`}
            py={theme.spacing(1)}
        >
            <Table aria-label={t.vat_breakdown} size="small">
                <TableBody>
                    <TableRow>
                        <TableCell component="th" scope="row" align="right" sx={cellSx}>
                            {capitalize(t.excl)}&nbsp;{t.vat}
                        </TableCell>
                        <TableCell align="right" sx={cellSx}>
                            {getLocaleNumberFormatTwoDecimals(
                                locale,
                                props.priceSummary.totalPriceExVat,
                            )}
                        </TableCell>
                    </TableRow>

                    {vatAmountInfoKeysSorted.map((key) => {
                        return props.priceSummary.vatAmountInfo[key] > 0 ? (
                            <TableRow key={key}>
                                <TableCell component="th" scope="row" align="right" sx={cellSx}>
                                    {t.vat}&nbsp;{`${key}%`}
                                </TableCell>
                                <TableCell align="right" sx={cellSx}>
                                    {getLocaleNumberFormatTwoDecimals(
                                        locale,
                                        props.priceSummary.vatAmountInfo[key],
                                    )}
                                </TableCell>
                            </TableRow>
                        ) : null;
                    })}
                </TableBody>
            </Table>
        </Box>
    );
}
